/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ContratFormateurSearch
 */
export interface ContratFormateurSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ContratFormateurSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ContratFormateurSearch
     */
    libelle?: TextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof ContratFormateurSearch
     */
    type?: Int32ListSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof ContratFormateurSearch
     */
    idGenre?: Int32ListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof ContratFormateurSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContratFormateurSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ContratFormateurSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ContratFormateurSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ContratFormateurSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ContratFormateurSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ContratFormateurSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ContratFormateurSearch interface.
 */
export function instanceOfContratFormateurSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContratFormateurSearchFromJSON(json: any): ContratFormateurSearch {
    return ContratFormateurSearchFromJSONTyped(json, false);
}

export function ContratFormateurSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContratFormateurSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'libelle': !exists(json, 'libelle') ? undefined : TextSearchFromJSON(json['libelle']),
        'type': !exists(json, 'type') ? undefined : Int32ListSearchFromJSON(json['type']),
        'idGenre': !exists(json, 'idGenre') ? undefined : Int32ListSearchFromJSON(json['idGenre']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ContratFormateurSearchToJSON(value?: ContratFormateurSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': TextSearchToJSON(value.code),
        'libelle': TextSearchToJSON(value.libelle),
        'type': Int32ListSearchToJSON(value.type),
        'idGenre': Int32ListSearchToJSON(value.idGenre),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

